import React from 'react';
import { LazyComponent } from '@fiverr-private/seller_pages_toolbox';

const lazyImport = () => import(/* webpackChunkName: 'LearnMoreModal' */ './index');

/** @type {import('./index').LearnMore} */
const LazyLearnMoreModal = ({ children, ...props }) => (
    <LazyComponent moduleName="LearnMoreModal" placeholder={children} componentProps={props} lazyImport={lazyImport}>
        {children}
    </LazyComponent>
);

export default LazyLearnMoreModal;
